"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Filter;

var _Filter = require("@adobe/react-spectrum-workflow/dist/Filter");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Filter(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Filter.A4uFilter, null));
}